import React from 'react'
import {Content} from '@builder.io/sdk-react'
import {customComponents} from 'hec/builder'
import {Heading} from '@/components/ui/heading'
import {BodyCopy} from '@/components/ui/body-copy'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useFetchOneEntry} from '@/hooks/useFetchOneEntry'
import modelMap from 'hec/builder/model-map'

const fallBackMessage = `No password? No problem. If we find a match in our system, you will receive an email with a link to help you log-in. If you do not receive an email in the next few minutes, please check your spam folder or re-send the magic link.`

const PasswordlessSuccess = () => {
    const config = getConfig()
    const {data: passwordlessMessage} = useFetchOneEntry({
        queryKey: [modelMap.signInLinkMessage],
        options: {
            model: modelMap.signInLinkMessage,
            apiKey: config.app.builder.api
        }
    })

    return (
        <div className="text-left" data-testid="passwordlessSuccess">
            <Heading
                variant="h5"
                className="font-grotesque"
                data-testid="passwordlessSuccess-Heading"
            >
                Your request for a Sign In Link has been received
            </Heading>
            {passwordlessMessage ? (
                <Content
                    model={modelMap.signInLinkMessage}
                    content={passwordlessMessage}
                    apiKey={config.app.builder.api}
                    customComponents={customComponents}
                    data-testid="passwordlessSuccess-BodyCopy"
                />
            ) : (
                <BodyCopy data-testid="passwordlessSuccess-BodyCopy">{fallBackMessage}</BodyCopy>
            )}
        </div>
    )
}

export default PasswordlessSuccess
